import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/profile/page.js");
